import React, { Fragment, PureComponent } from "react";
import {
  LineChart,
  Line,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Legend,
  // Rectangle,
  // LabelList,
  ResponsiveContainer,
  ReferenceLine,
  LabelList,
  Bar,
  BarChart,
  Brush
} from "recharts";
import styles from "./Charts.local.scss";
import {
  CustomizedXAxisTick,
  CustomizedYAxisTick,
  CustomTooltip
} from "./Common";
import { Modal } from "antd";
import { CustomizedLabel } from "./StandardBarChart";

const colors = [
  "#2495E1",
  "#F84154",
  "#FA9437",
  "#87E9FB",
  "#5FFF6B",
  "#1824ff"
];

const children = {
  "400": {
    label: "Clients",
    children: ["400000", "400001"]
  },
  "440": {
    label: "Fournisseurs",
    children: ["440000"]
  },
  "0_REXEUCI": {
    label: "Evolution du résultat après impôt",
    children: ["77", "67", "0_REXUC"]
  },
  "0_CF": {
    label: "Evolution du Cash Flow",
    children: [
      "0_REXEUCI",
      "631",
      "634",
      "637",
      "641",
      "642",
      "652",
      "653",
      "656",
      "660",
      "661",
      "662",
      "663",
      "752",
      "760",
      "761",
      "762",
      "772"
    ]
  },
  "0_DIF": {
    label: "Degré d'indépendance financière",
    children: ["0_CP", "0_10:15"]
  },
  "0_NJCC": {
    label: "Nombre de jours crédit clients",
    children: ["290", "70", "74"]
  },
  "0_NJCF": {
    label: "Nombre de jours crédit Fournisseurs",
    children: ["44", "0_AM", "609", "61"]
  },
  "0_TR": {
    label: "Tréssorerie",
    children: ["0_AD", "0_DCTF"]
  },
  "0_FRPE": {
    label: "Le fond de roulement (permanents)",
    children: ["0_PP", "0_AF"]
  },
  "0_BFR": {
    label: "Besoin en fond de roulement",
    children: ["0_AR", "0_DCTE"]
  }
};

export class StandardLineChart extends PureComponent {
  state = {
    showModal: false,
    chartData: []
  };

  handleLineClick = data => {
    const { activeLabel } = data && data;
    const { chartData, dataKeyX } = this.props;
    const dataK =
      chartData &&
      chartData.find(
        item => dataKeyX && item[dataKeyX] === activeLabel && activeLabel
      );
    if (chartData) {
      const keys = Object.keys(dataK).filter(
        key => key !== "year" && key !== "children"
      );

      if (keys) {
        const childrenKeys = keys.map(key => ({
          label: children[key].label,
          dataKeys: children[key].children.map(
            k => (k ? dataK.children[k] : [])
          )
        }));

        this.setState({
          showModal: true,
          chartData: childrenKeys
        });
      }
    }
  };

  handleOnClose = () => {
    this.setState({
      showModal: false,
      chartData: []
    });
  };

  renderModalContent = label => {
    const { chartData, showModal } = this.state;
    if (!chartData) {
      return;
    }
    return (
      <Modal
        visible={showModal}
        width="90%"
        bodyStyle={{ maxHeight: "90vh", overflowY: "auto" }}
        onCancel={this.handleOnClose}
        footer={null}
      >
        {chartData.map((child, index) => (
          <div
            key={index}
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center"
            }}
          >
            <ResponsiveContainer
              key={index}
              width="100%"
              height={400}
              className={styles.charts_font}
            >
              <BarChart
                data={child.dataKeys}
                margin={{ top: 30, right: 40, left: 15, bottom: 5 }}
              >
                <CartesianGrid
                  vertical={false}
                  stroke="#6d7f92"
                  strokeWidth={0.2}
                />
                <XAxis
                  dataKey="label"
                  height={50}
                  interval={0}
                  padding={{ left: 30, right: 30 }}
                  type="category"
                  tick={<CustomizedXAxisTick />}
                  axisLine={false}
                  tickLine={false}
                />
                <YAxis
                  tick={<CustomizedYAxisTick />}
                  axisLine={false}
                  tickLine={false}
                  type={"number"}
                />
                <Tooltip content={<CustomTooltip />} />
                <Legend
                  verticalAlign="top"
                  height={20}
                  iconType={"square"}
                  iconSize={12}
                  layout="horizontal"
                  wrapperStyle={{
                    left: 42,
                    top: 0,
                    bottom: 15,
                    fontWeight: 300,
                    fontSize: "14px"
                  }}
                />
                <ReferenceLine y={0} stroke="#6d7f9271" />
                <Brush dataKey="label" height={30} stroke="#8884d8" />
                <Bar
                  name={child.label}
                  dataKey="value"
                  fill={colors[index % colors.length]}
                  animationEasing={"ease-in-out"}
                  animationDuration={800}
                  barSize={65}
                >
                  <LabelList
                    dataKey="value"
                    position="top"
                    content={<CustomizedLabel />}
                  />
                </Bar>
              </BarChart>
            </ResponsiveContainer>
          </div>
        ))}
      </Modal>
    );
  };

  render() {
    const {
      chartData,
      dataKeysY,
      dataKeyX,
      currency,
      legendLabels,
      containerWidth,
      containerHeight
    } = this.props;
    return (
      <Fragment>
        <ResponsiveContainer
          width={containerWidth ? containerWidth : "100%"}
          height={containerHeight ? containerHeight : 340}
          className={styles.charts_font}
        >
          <LineChart
            data={chartData}
            margin={{ top: 30, right: 40, left: 15, bottom: 5 }}
            onClick={e => this.handleLineClick(e)}
          >
            <CartesianGrid
              vertical={false}
              stroke="#6d7f92"
              strokeWidth={0.2}
            />
            <XAxis
              name={dataKeyX}
              dataKey={dataKeyX}
              height={50}
              interval={0}
              padding={{ left: 30, right: 30 }}
              type="category"
              tick={<CustomizedXAxisTick />}
              axisLine={false}
              tickLine={false}
            />
            <YAxis
              tick={<CustomizedYAxisTick currency={currency} />}
              axisLine={false}
              tickLine={false}
              type={"number"}
            />
            <Tooltip content={<CustomTooltip />} />
            <Legend
              verticalAlign="top"
              height={containerHeight ? 20 : 70}
              // align={"center"}
              iconType={"square"}
              iconSize={12}
              layout={containerHeight ? "horizontal" : "vertical"}
              wrapperStyle={{
                left: 42,
                top: 0,
                fontWeight: 300,
                fontSize: "14px"
              }}
            />
            <ReferenceLine y={0} stroke="#6d7f9271" />

            {dataKeysY.map((item, i) => {
              return (
                <Line
                  key={i}
                  name={legendLabels[i]}
                  type="monotone"
                  dataKey={dataKeysY[i]}
                  stroke={colors[i]}
                  fill={colors[i]}
                  dot={{ fill: colors[i], strokeWidth: 4 }}
                  strokeWidth={2.5}
                  animationEasing={"ease-in-out"}
                  animationDuration={800}
                />
              );
            })}
          </LineChart>
        </ResponsiveContainer>
        {this.renderModalContent(legendLabels)}
      </Fragment>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/Common/Charts/StandardLineChart.js